import { Heading } from "./Heading";
import {
  componentSpace,
  componentSpaceMobile,
  lineHeight,
  middleSpace,
  middleSpaceMobile,
  smallSpace,
  styles,
} from "../../../theme/styles";
import { useMediaQuery, useTheme } from "@mui/material";

export const WelcomeCoach = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <>
      <Heading
        variant={"h2"}
        style={
          isDesktop
            ? { marginTop: componentSpace, padding: "0px", lineHeight }
            : {
                marginTop: componentSpaceMobile,
                padding: "0px",
                lineHeight,
              }
        }
      >
        Converta seu conhecimento em uma<br/><label style={styles.greenLabel}>AI para formar pro players </label>
        {/* <label style={styles.greenLabel}>Transforme </label>
         seu conhecimento em uma
        <label style={styles.greenLabel}> AI </label>
        moldando os pro players do futuro */}
      </Heading>
      <Heading
        variant={"h5"}
        style={
          isDesktop
            ? {
                fontSize: "16px",
                marginBottom: middleSpace,
                marginTop: smallSpace,
              }
            : {
                fontSize: "16px",
                marginBottom: middleSpaceMobile,
                marginTop: smallSpace,
              }
        }
      >
        Defina sua estratégia, treine sua IA e transforme seu conhecimento em lucro
      </Heading>
    </>
  );
};
